export class StatusIcons {
  public static readonly Warning = '../../../../assets/icons/icon_warning.svg';
  public static readonly Success = '../../../../assets/icons/icon_success.svg';
  public static readonly Failed = '../../../../assets/icons/icon_error.svg';
}
